export const COOKIE_MAX_AGE = 31; //cookie最大有效期， 默认为：7天
export const COOKIE_HOST_DOMAIN = 'secoo.com'; //cookie设置的域名
export const CHANNEL_MARKING = 60; // M站渠道标识 (Channel Marking)

export const LOGIN_SUCESS_REDIRECT_URLS_CONFIG = {
    cart: {//确认下单页
        url: '/settleCenter.html',
        params: null
    },
    newAuctionDetail: { //拍卖页1
        url: '/newAuctionDetail.html',
        params: ['productId', 'activityId']
    },
    newAuctionDetail2: { //拍卖页2
        url: '/newAuctionDetail2.html',
        params: ['productId', 'activityId']
    },
    auctionDetailWrapper: { //拍卖页3
        url: '/auctionDetailWrapper.html',
        params: ['pid', 'status']
    },
    shoppingCart: { //结算中心 购物车 商品未加入云购物车 结算中心 bug 规避暂时去购物车页面
        url: '/shoppingCart.html',
        params: null
    },
    activityName: { //精切专题页, 备注：此页面地址为[拼接地址],根据refSearch标识开拼接
        url: '/appActivity/',
        params: ['pcdate', 'refSearch']
    },
    proDetail_1217: { //商品详情页
        url: '/proDetail_1217.html',
        params: ['mixinParam']
    },
    default: { //用户中心页
        url: '/user.html',
        params: null
    }
};



// WEBPACK FOOTER //
// ./src/config/index.js